import { Component, Input } from '@angular/core';
import { Testigo } from '../model/testigo';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact-testigo-modal',
  templateUrl: './enviar-correo-testigo.component.html',
  styleUrls: ['./enviar-correo-testigo.component.css']
})
export class EnviarCorreoTestigoComponent {
  @Input() testigo?: Testigo;

  mensaje: string = '';
  isLoading: boolean = false;

  myForm: FormGroup;
  infoEmail: string;
  charCount: number = 0;
  maxCharCount: number = 4000;
  private lastValidHTML: string = '';

  constructor(private apiService: ApiService, private router: Router, private auth: AuthService, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit(): void {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    this.myForm = new FormGroup({
      email: new FormControl(this.testigo?.correo_testigo || '', [Validators.required, Validators.email]),
      infoEmail: new FormControl('', [Validators.maxLength(4000), Validators.required]),
    });

    this.updateCharCount();
    this.testigo.correo_testigo.length === 0 ? this.isLoading = true : this.isLoading = false;
  }

  get email() {
    return this.myForm.get('email');
  }

  get texto() {
    return this.myForm.get('infoEmail');
  }

  // Subscribe to value changes to always keep the character count updated.
  updateCharCount() {
    this.myForm.get('infoEmail')?.valueChanges.subscribe((value: string) => {
      this.charCount = value ? value.length : 0;
      this.charCount === 0 ? this.isLoading = true : this.isLoading = false;
    });
  }

  // Validates HTML input, updates character count, and reverts to last valid value if limit is exceeded.
  onEditorChange(value: string) {
    const plainText = value
      ? value.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim()
      : '';

    if (plainText.length <= this.maxCharCount) {
      this.lastValidHTML = value;
      this.charCount = plainText.length;
    } else {
      this.myForm
        .get('infoEmail')
        ?.setValue(this.lastValidHTML, { emitEvent: false });

      const lastPlainText = this.lastValidHTML
        ? this.lastValidHTML.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim()
        : '';
      this.charCount = lastPlainText.length;
    }
  }

  //Método para el envío del correo al testigo
  enviarCorreo() {

    if (this.charCount > 4000) {
      this.toastr.error(this.translate.instant('texto_266'), this.translate.instant('texto_243'));
      return;
    }

    if (this.myForm.invalid) {
      this.toastr.error(this.translate.instant('texto_243'));
      return;
    }

    this.isLoading = true;

    const emailValue = this.myForm.get('email')?.value;
    const messageValue = this.myForm.get('infoEmail')?.value;

    const emailData = {
      id_user: emailValue,
      subject: 'Contacto con equipo gestor',
      message: this.translate.instant('texto_886') + '<br><br>' + messageValue + '<br><br>',
      boton: '',
      clausulas: true,
      titulo: 'Contacto con equipo gestor'
    };

    this.apiService.sendEmail(
      emailData.id_user,
      emailData.subject,
      emailData.message,
      emailData.boton,
      emailData.clausulas,
      emailData.titulo,
      'gestor'
    ).subscribe({
      next: (response) => {
        this.isLoading = false;
          this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));

          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['editar-denuncia/', this.testigo.id_denuncia]);
        });
      },
      error: (error) => {
        this.isLoading = false;
          this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));

          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['editar-denuncia/', this.testigo.id_denuncia]);
        });
      }
    });

  }

  onEmailInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.myForm.get('email')?.setValue(input.value);
  }

}
